import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'report/properties/style/graph-color.ejs';
import { pickerCfg } from 'pickerCfg';
import util             from 'util/Util.js';
import themeService     from 'ThemeService.js';

class StyleGraphColorView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=color]': 'updateColorAttributes',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        return this;
    }

    render() {
        super.render();

        let props = this.model.toJSON();
        props.barColor = themeService.resolve(props.barColor) ;
        props.axisColor = themeService.resolve(props.axisColor);
        //console.log('on render on style ', props)
        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        if (this.model.get('factoryKey') === 'control_line_chart') {
            $('#lineColorProp').removeClass('hide');
        }

        if (this.model.get('factoryKey') === 'control_bar_chart') {
            $('#barsColorProp').removeClass('hide');
        }

        this.delegateEvents();

        return this;
    }

}

export default StyleGraphColorView;
